import { Map } from 'immutable';

import * as type from './actionTypes';
import * as typeSagas from './actionTypesSagas';

const initialState = Map({
  audioAbbreviations: { data: [], pagination: {} },
  isAudioAbbreviationsImportingLoading: false,
});

export default function audioAbbreviationsReducer(
  state = initialState,
  action,
) {
  switch (action.type) {
    // Audio Abbreviations
    case type.SET_ALL_AUDIO_ABBREVIATIONS: {
      const audioAbbreviations = { ...action.payload.abbreviations };
      return state
        .set('audioAbbreviations', audioAbbreviations)
        .set('isAudioAbbreviationsImportingLoading', false);
    }
    case type.CLEAR_AUDIO_ABBREVIATIONS: {
      return state
        .set('audioAbbreviations', {})
        .set('isAudioAbbreviationsImportingLoading', false);
    }

    case typeSagas.DELETE_AUDIO_ABBREVIATION: {
      const audioAbbreviations = state.get('audioAbbreviations');
      const audioAbbreviationsData = audioAbbreviations.data;

      const oldOrderIdx = audioAbbreviationsData.find(
        (a) => a.id === action.payload.abbreviation.id,
      )?.orderIdx;

      // Similar logic to AudioAbbreviation.rearrangeRemainingAbbreviations()
      // Refer to AudioAbbreviation.test.js for examples
      const updates = audioAbbreviationsData
        .filter((a) => a.orderIdx > oldOrderIdx)
        .map((a) => ({ ...a, orderIdx: a.orderIdx - 1 }));

      const updatedAbbreviations = audioAbbreviationsData
        .map((original) => {
          const updated = updates.find((u) => u.id === original.id);
          if (updated) return updated;
          return original;
        })
        .filter((updated) => updated.id !== action.payload.abbreviation.id);

      return state.set('audioAbbreviations', {
        ...audioAbbreviations,
        data: updatedAbbreviations,
      });
    }

    case typeSagas.CREATE_OR_UPDATE_MULTIPLE_AUDIO_ABBREVIATIONS: {
      return state.set('isAudioAbbreviationsImportingLoading', true);
    }
    case typeSagas.CREATE_OR_UPDATE_MULTIPLE_AUDIO_ABBREVIATIONS_FAIL: {
      return state.set('isAudioAbbreviationsImportingLoading', false);
    }
    default:
      return state;
  }
}
